module.exports = __webpack_public_path__ + "static/media/update parent regist.daf2983f.svg";